export const billingInfoSchema = {
  title: "Billing Information",
  type: "object",
  required: ["billingInfoSection0"],
  properties: {
    billingInfoSection0: {
      type: "object",
      title: "Billing Information",
      description:
        "All invoices will be sent via email, please select client billing contact.",
      properties: {
        recipientType: {
          type: "string",
          title: "To whom should bills be sent?",
          oneOf: [
            { const: "client", title: "Client" },
            { const: "authorizedContact", title: "Other" },
          ],
          default: "client",
        },
        sendMethod: {
          type: "string",
          title: "How should bills be sent?",
          enum: ["Email", "Mail"],
          default: "Email",
        },
      },
      dependencies: {
        recipientType: {
          oneOf: [
            {
              properties: {
                recipientType: { const: "client" },
              },
            },
            {
              properties: {
                recipientType: { const: "authorizedContact" },
                selectedContactId: {
                  type: "string",
                  title: "Select Billing Contact",
                  pattern: "^\\d*$", // digits or empty string
                  errorMessage: {
                    pattern: "Invalid contact selection",
                  },
                },
                billingContactFirstName: {
                  type: "string",
                  title: "Billing Recipient First Name",
                  minLength: 1,
                  maxLength: 25,
                  errorMessage: {
                    required: "First name is required",
                    minLength: "First name is required",
                    maxLength: "First name must be under 25 characters",
                  },
                },
                billingContactLastName: {
                  type: "string",
                  title: "Billing Recipient Last Name",
                  maxLength: 25,
                  minLength: 1,
                  errorMessage: {
                    required: "Last name is required",
                    minLength: "Last name is required",
                    maxLength: "Last name must be under 25 characters",
                  },
                },
                billingContactPhone: {
                  type: "string",
                  format: "phone",
                  title: "Billing Recipient Phone",
                  pattern: "^\\(\\d{3}\\) \\d{3}-\\d{4}$",
                  errorMessage: {
                    required: "Phone number is required",
                    pattern:
                      "Enter a valid phone number in format (xxx) xxx-xxxx",
                  },
                },
                billingContactEmail: {
                  type: "string",
                  format: "email",
                  title: "Billing Recipient Email",
                  maxLength: 85,
                  errorMessage: {
                    required: "Please enter a valid email address",
                    format: "Please enter a valid email address",
                    maxLength: "Email must be under 85 characters",
                  },
                },
                billingStreetAddress: {
                  type: "string",
                  title: "Street Address",
                  minLength: 1,
                  maxLength: 65,
                  errorMessage: {
                    required: "Street address is required",
                    minLength: "Street address is required",
                    maxLength: "Street address must be under 65 characters",
                  },
                },
                billingCity: {
                  type: "string",
                  title: "City",
                  minLength: 1,
                  maxLength: 30,
                  errorMessage: {
                    required: "City is required",
                    minLength: "City cannot be empty",
                    maxLength: "City must be under 30 characters",
                  },
                },
                billingState: {
                  type: "string",
                  title: "State",
                  minLength: 1,
                  errorMessage: {
                    required: "State is required",
                    minLength: "State is required",
                  },
                },
                billingZipCode: {
                  type: "string",
                  title: "ZIP Code",
                  pattern: "^[0-9]{5}$",
                  errorMessage: {
                    required: "ZIP code is required",
                    pattern: "ZIP code must be exactly 5 digits",
                  },
                },
              },
              required: [
                "billingContactFirstName",
                "billingContactLastName",
                "billingContactPhone",
                "billingContactEmail",
                "billingStreetAddress",
                "billingCity",
                "billingState",
                "billingZipCode",
              ],
            },
          ],
        },
      },
    },
  },
};

export const billingInfoUiSchema = {
  billingInfoSection0: {
    "ui:order": [
      "recipientType",
      "selectedContactId",
      "billingContactFirstName",
      "billingContactLastName",
      "billingContactPhone",
      "billingContactEmail",
      "billingStreetAddress",
      "billingCity",
      "billingState",
      "billingZipCode",
      "sendMethod",
    ],
    recipientType: {
      "ui:widget": "RadioDescriptionWidget",
      "ui:options": {
        description: "Select the billing recipient",
        inline: false,
        label: false,
      },
      "ui:md": 12,
    },
    selectedContactId: {
      "ui:field": "ContactDropdownField",
      "ui:options": {
        hideError: true,
        contacts: [],
        labelKey: "fullName",
        description: "Choose a contact previously added to handle billing.",
      },
      "ui:md": 12,
    },
    sendMethod: {
      "ui:widget": "RadioDescriptionWidget",
      "ui:options": {
        description: "Select your preferred method of receiving bills",
        inline: false,
        label: false,
      },
      "ui:md": 12,
    },
    billingContactFirstName: { "ui:md": 6 },
    billingContactLastName: { "ui:md": 6 },
    billingContactPhone: {
      "ui:md": 6,
      "ui:widget": "PhoneWidget",
      "ui:options": {
        inputType: "tel",
        disabled: false,
        readonly: false,
        hideError: false,
      },
    },
    billingContactEmail: { "ui:md": 6 },
    billingStreetAddress: { "ui:md": 6 },
    billingCity: { "ui:md": 6 },
    billingState: {
      "ui:md": 6,
      "ui:field": "StateField",
      "ui:options": {
        hideError: true,
      },
    },
    billingZipCode: {
      "ui:md": 6,
      "ui:widget": "NumberWidget",
      "ui:options": {
        hideError: false,
        digitsOnly: true,
        maxLength: 5,
        inputMode: "numeric",
      },
    },
  },
};
